export default "__VITE_ASSET__D0guC1Bw__"